// @flow
import { handleActions } from 'redux-actions';
import { List } from 'immutable';

import { upsertResource, upsertResources } from 'data/qcsSyncResourceReducerHelpers';

import * as actions from './actions';

import { Institution, InstitutionsStore, mkInstitutionsStore } from './types';
import type {QcsSyncResourcesPayload} from '../qcsSyncResourceTypes';

const reducer = handleActions({

  [actions.getInstitution]:
    (state :InstitutionsStore) => state,

  [actions.getInstitutionResponse]: {
    next(state: InstitutionsStore, { payload: institutionToUpsert }: { payload: Institution }) {
      return upsertResource(state.set('isLoading', false), institutionToUpsert);
    },
  },

  [actions.getPopularInstitutionsSuccess]:
    (state: InstitutionsStore, { payload }: { payload: QcsSyncResourcesPayload }) => {
      let newState: InstitutionsStore = upsertResources(state.set('isLoading', false), payload);
      newState = newState.set('popularIds', List(payload.resources.map((resource) => resource.id)));
      return newState;
    },

}, mkInstitutionsStore());

export const REDUCER_KEY = 'institutionsStore';
export default reducer;
